import { EM_DASH } from 'constants/index';
import { HeaterStatus } from 'types/models/heater';

const FIRST_BIT_MASK = 0b1;
const isFirstBitOn = (num: number): boolean => {
  if (!Number.isInteger(num)) {
    throw new Error('num must be an integer');
  }
  return (num & FIRST_BIT_MASK) !== 0;
};

export const getHeaterStatus = (sampleRwValue?: number): HeaterStatus | typeof EM_DASH => {
  if (sampleRwValue === undefined) return EM_DASH;
  if (isFirstBitOn(sampleRwValue)) {
    return HeaterStatus.ON;
  }
  return HeaterStatus.OFF;
};